import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function TickSquare({
  outline,
  ...props
}: IconProps): JSX.Element {
  return outline ? (
    <TickSquare.Outline {...props} />
  ) : (
    <TickSquare.Solid {...props} />
  );
}

TickSquare.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M16.0903 10.1573C16.3832 9.86439 16.3832 9.38952 16.0903 9.09662C15.7974 8.80373 15.3225 8.80373 15.0296 9.09662L10.8138 13.3124L8.97016 11.4695C8.6772 11.1767 8.20233 11.1768 7.9095 11.4697C7.61667 11.7627 7.61677 12.2376 7.90972 12.5304L10.2837 14.9034C10.5766 15.1962 11.0514 15.1961 11.3443 14.9033L16.0903 10.1573Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.66549 2C5.9692 2 4.53397 2.60562 3.52648 3.6865C2.52445 4.76152 2.00049 6.24677 2.00049 7.916V16.084C2.00049 17.7523 2.52164 19.2377 3.52277 20.3131C4.52955 21.3947 5.96518 22 7.66549 22H16.3335C18.0342 22 19.4703 21.3948 20.4775 20.3133C21.479 19.2378 22.0005 17.7524 22.0005 16.084V7.916C22.0005 6.2476 21.479 4.76222 20.4776 3.68678C19.4706 2.6053 18.0348 2 16.3345 2H7.66549ZM3.50049 7.916C3.50049 6.55823 3.92353 5.46048 4.62374 4.70925C5.3185 3.96388 6.34078 3.5 7.66549 3.5H16.3345C17.6642 3.5 18.6864 3.9642 19.3798 4.70897C20.079 5.45978 20.5005 6.5574 20.5005 7.916V16.084C20.5005 17.4426 20.079 18.5402 19.3798 19.291C18.6862 20.0357 17.6638 20.5 16.3335 20.5H7.66549C6.33579 20.5 5.31393 20.0358 4.6207 19.2911C3.92183 18.5403 3.50049 17.4427 3.50049 16.084V7.916Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

TickSquare.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        <path
          id="Fill 1"
          d="M16.359 2.92542H7.68904C4.29904 2.92542 2.01904 5.30542 2.01904 8.84542V17.0154C2.01904 20.5454 4.29904 22.9254 7.68904 22.9254H16.359C19.749 22.9254 22.019 20.5454 22.019 17.0154V8.84542C22.019 5.30542 19.749 2.92542 16.359 2.92542Z"
          fill="currentColor"
          className="icon-secondary"
        />
        <path
          id="Fill 4"
          d="M10.8321 16.1735C10.6081 16.1735 10.3841 16.0885 10.2131 15.9175L7.84012 13.5445C7.49812 13.2025 7.49812 12.6485 7.84012 12.3075C8.18212 11.9655 8.73512 11.9645 9.07712 12.3065L10.8321 14.0615L14.9601 9.9335C15.3021 9.5915 15.8551 9.5915 16.1971 9.9335C16.5391 10.2755 16.5391 10.8295 16.1971 11.1715L11.4511 15.9175C11.2801 16.0885 11.0561 16.1735 10.8321 16.1735Z"
          fill="currentColor"
          className="icon-primary"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
